import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { FLAVORS, FLAVOR_PILLS } from './salesData';

/** Pequeñas variaciones de composición para que no se lea como plantilla. */
const TILT = ['sm:-rotate-1', 'sm:rotate-1', 'sm:-rotate-1', 'sm:rotate-1', 'sm:-rotate-1'];

/**
 * VARIEDAD. Escaparate de pastelería: fotografía grande de cookies abiertas.
 * La primera variedad manda con una tarjeta a doble ancho y texto sobre la foto.
 */
export function FlavorsSection() {
  const [hero, ...rest] = FLAVORS;
  return <section id="sabores" className="scroll-mt-24 overflow-hidden bg-ivory py-14 sm:py-20" aria-labelledby="flavors-title" data-id="element-168" data-mp="3e52jotun54ry">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-169" data-mp="34dy720sftw0a">
        <div className="max-w-2xl" data-id="element-170" data-mp="34bbx5ui2r4ew">
          <SectionTag data-id="element-171" data-mp="5nfuku64yz09">Los sabores</SectionTag>
          <h2 id="flavors-title" className="mt-4 font-display text-[1.95rem] leading-[1.06] text-charcoal sm:text-[2.7rem]" data-id="element-172" data-mp="5p93kg481vbf">
            100 recetas. Un mundo de cookies para descubrir.
          </h2>
          <p className="mt-4 font-sans text-[0.95rem] leading-relaxed text-charcoal-mid" data-id="element-173" data-mp="14mnzrkoaz7tr">
            Desde sabores clásicos hasta combinaciones premium, vas a tener ideas para crear un
            catálogo mucho más amplio y atractivo.
          </p>
        </div>

        {/* Variedad protagonista: la foto ocupa todo y el texto vive encima. */}
        <motion.figure initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.25
      }} transition={{
        duration: 0.32,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mt-9 overflow-hidden rounded-5xl shadow-bakery" data-id="element-174" data-mp="gvs58fsgpyit">
          <img src={hero.image} alt={hero.alt} loading="lazy" decoding="async" className="aspect-[4/5] w-full object-cover sm:aspect-[16/9]" data-id="element-175" data-mp="c0cs5q2a46ng" />
          <figcaption className="absolute inset-x-0 bottom-0 bg-charcoal/65 px-5 py-5 backdrop-blur-sm sm:px-9 sm:py-7" data-id="element-176" data-mp="269x55fu69ka7">
            <span className="font-sans text-[0.58rem] font-bold uppercase tracking-editorial text-gold-pale" data-id="element-177" data-mp="1zvhx6b7tktyy">
              {hero.tag}
            </span>
            <h3 className="mt-1.5 font-display text-[1.5rem] leading-tight text-ivory sm:text-[2.2rem]" data-id="element-178" data-mp="1ux6m5x5sgdf5">
              {hero.name}
            </h3>
            <p className="mt-1.5 max-w-md font-sans text-[0.86rem] leading-snug text-ivory/75 sm:text-[0.98rem]" data-id="element-179" data-mp="2nm55gxlndlm1">
              {hero.note}
            </p>
          </figcaption>
        </motion.figure>

        <ul className="mt-5 grid grid-cols-2 gap-4 sm:grid-cols-3 sm:gap-6 lg:grid-cols-5" data-id="element-180" data-mp="2dvaly0zsd04a">
          {rest.map((flavor, index) => <motion.li key={flavor.id} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.25
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1],
          delay: index % 3 * 0.04
        }} className={`${TILT[index % TILT.length]} transition-transform duration-200 ease-out hover:rotate-0`} data-id="element-181" data-mp="28w68uz9qqi8o" data-mpi={index}>
              <figure className="group flex h-full flex-col" data-id="element-182" data-mp="3it4dnxmv0thc">
                <div className="overflow-hidden rounded-4xl shadow-bakery-sm" data-id="element-183" data-mp="3nubne28kc2qn">
                  <img src={flavor.image} alt={flavor.alt} loading="lazy" decoding="async" className="aspect-[4/5] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.04]" data-id="element-184" data-mp="3ssv85zbf78hf" />
                </div>
                <figcaption className="mt-3.5 flex flex-1 flex-col px-1" data-id="element-185" data-mp="adkopat81x83">
                  <span className="font-sans text-[0.55rem] font-bold uppercase tracking-editorial text-berry" data-id="element-186" data-mp="feifgbsarzl7">
                    {flavor.tag}
                  </span>
                  <h3 className="mt-1 font-display text-[1.05rem] leading-tight text-charcoal sm:text-[1.15rem]" data-id="element-187" data-mp="kapgbq5u6kwa">
                    {flavor.name}
                  </h3>
                  <p className="mt-1.5 font-sans text-[0.78rem] leading-snug text-charcoal/55 sm:text-[0.84rem]" data-id="element-188" data-mp="1c53ryb3ifig3">
                    {flavor.note}
                  </p>
                </figcaption>
              </figure>
            </motion.li>)}
        </ul>

        <div className="mt-12 rounded-5xl bg-pistacho-pale px-5 py-8 sm:px-10 sm:py-10" data-id="element-189" data-mp="y4t3fepoafy3">
          <p className="font-sans text-[0.6rem] font-bold uppercase tracking-editorial text-charcoal/50" data-id="element-190" data-mp="t7b0q6290wyj">
            Y muchos más entre las 100 variedades
          </p>
          <ul className="mt-4 flex flex-wrap gap-2.5" data-id="element-191" data-mp="134p537awdvah">
            {FLAVOR_PILLS.map(pill => <li key={pill} className="rounded-full bg-ivory px-4 py-2 font-sans text-[0.76rem] font-medium text-charcoal/75 shadow-[0_6px_14px_-10px_rgba(53,47,50,0.35)] sm:text-[0.85rem]" data-id="element-192" data-mp="2ilfueodd7mhh">
                {pill}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}